import React from "react";

// Constants
import { ROOT_CONSTANT, COMMON_FEATURES } from "../../constants";

// Services

const {
  icon_dashboard,
  icon_payroll,
  icon_user,
  icon_billing,
  icon_logout,
  icon_company,
  icon_profile,
} = ROOT_CONSTANT.IMG.ICON.MENU;

const { FEATURE_NAME, FEATURE_TYPE } = COMMON_FEATURES;

export const FEATURE_LABEL = {
  // App Info
  [FEATURE_NAME.DASHBOARD]: "Dashboard",
  [FEATURE_NAME.LOGOUT]: "Log out",

  // Payroll
  [FEATURE_NAME.PAYROLL_ADVANCE_MANAGEMENT]: "Payroll Advance Management",
  [FEATURE_NAME.PAYROLL_ADVANCE_LIST]: "Payroll Advance List",

  // Company Management
  [FEATURE_NAME.COMPANY_MANAGEMENT]: "Company Management",
  [FEATURE_NAME.COMPANY_LIST]: "Company List",

  // User
  [FEATURE_NAME.USER_MANAGEMENT]: "User Management",
  [FEATURE_NAME.EMPLOYEE]: "Employee List",
  [FEATURE_NAME.EMPLOYER]: "Employer List",

  // Billing
  [FEATURE_NAME.BILLING_MANAGEMENT]: "Billing Management",
  [FEATURE_NAME.BILLING_LIST]: "Billing List",

  // Profile
  [FEATURE_NAME.PROFILE]: "Profile",
};

const MENU_ICON_SIZE = 18;

const MENU_COMPONENT_ITEM = (menu) => ({
  key: menu.feature,
  icon:
    (menu.icon && <menu.icon style={{ fontSize: MENU_ICON_SIZE }} />) || null,
  label: FEATURE_LABEL[menu.feature],
  feature: menu.feature,
  type: menu.type || null,
  children:
    (menu.children && menu.children.map((m) => MENU_COMPONENT_ITEM(m))) || [],
  disabled: menu.disabled,
  function: menu.function,
});

export const FEATURE_MENU_ITEMS_OBJ = {
  [FEATURE_NAME.DASHBOARD]: {
    feature: FEATURE_NAME.DASHBOARD,
    icon: icon_dashboard,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.LOGOUT]: {
    feature: FEATURE_NAME.LOGOUT,
    icon: icon_logout,
    type: FEATURE_TYPE.LOGOUT,
    disabled: false,
  },
  [FEATURE_NAME.PAYROLL_ADVANCE_MANAGEMENT]: {
    feature: FEATURE_NAME.PAYROLL_ADVANCE_MANAGEMENT,
    icon: icon_payroll,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.PAYROLL_ADVANCE_LIST]: {
    feature: FEATURE_NAME.PAYROLL_ADVANCE_LIST,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.COMPANY_MANAGEMENT]: {
    feature: FEATURE_NAME.COMPANY_MANAGEMENT,
    icon: icon_company,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.COMPANY_LIST]: {
    feature: FEATURE_NAME.COMPANY_LIST,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.USER_MANAGEMENT]: {
    feature: FEATURE_NAME.USER_MANAGEMENT,
    icon: icon_user,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.EMPLOYEE]: {
    feature: FEATURE_NAME.EMPLOYEE,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.EMPLOYER]: {
    feature: FEATURE_NAME.EMPLOYER,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.BILLING_MANAGEMENT]: {
    feature: FEATURE_NAME.BILLING_MANAGEMENT,
    icon: icon_billing,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.BILLING_LIST]: {
    feature: FEATURE_NAME.BILLING_LIST,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
  [FEATURE_NAME.PROFILE]: {
    feature: FEATURE_NAME.PROFILE,
    icon: icon_profile,
    type: FEATURE_TYPE.ROUTE,
    disabled: false,
  },
};

export const FEATURE_MENU_ITEMS = Object.values(FEATURE_MENU_ITEMS_OBJ);

export const FEATURE_MENU_ITEMS_LAYER_FIRST = (role) => {
  const menuItems = [
    {
      ...FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.PAYROLL_ADVANCE_MANAGEMENT],
      children: [FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.PAYROLL_ADVANCE_LIST]],
    },
    {
      ...FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.USER_MANAGEMENT],
      children: [
        ...(role === "A"
          ? [FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.EMPLOYER]]
          : []),
        FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.EMPLOYEE],
      ],
    },
    {
      ...FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.BILLING_MANAGEMENT],
      children: [FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.BILLING_LIST]],
    },
    FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.PROFILE],
  ];

  if (role === "A") {
    const companyManagementItem = {
      ...FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.COMPANY_MANAGEMENT],
      children: [FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.COMPANY_LIST]],
    };
    menuItems.splice(2, 0, companyManagementItem);

    
    const Dashboard = {
      ...FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.DASHBOARD],
    };
    menuItems.splice(0, 0, Dashboard);
  }
  return menuItems;
};

export const FEATURE_MENU_ITEMS_LAYER_SECOND = [
  {
    type: "group",
    children: [FEATURE_MENU_ITEMS_OBJ[FEATURE_NAME.LOGOUT]],
  },
];

export const FEATURE_MENU_ITEMS_COMP = FEATURE_MENU_ITEMS.map((menu) =>
  MENU_COMPONENT_ITEM(menu)
);

export const FEATURE_MENU_ITEMS_COMP_LAYER_FIRST = (role) =>
  FEATURE_MENU_ITEMS_LAYER_FIRST(role).map((menu) => MENU_COMPONENT_ITEM(menu));

export const FEATURE_MENU_ITEMS_COMP_LAYER_SECOND =
  FEATURE_MENU_ITEMS_LAYER_SECOND.map((menu) => MENU_COMPONENT_ITEM(menu));
